export const emptyFocused = "GOb";
export const emptyOther = "HOb";
export const emptyFolder = "IOb";
export default {emptyFocused,emptyOther,emptyFolder};